import { mutatorAction } from "satcheljs";
import { SchedulesViewStateStore } from "sh-application/components/schedules/lib/store/schema/SchedulesViewStateStore";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";

export default mutatorAction('SET_SCHEDULE_HEADER_STICKY', function setScheduleHeaderSticky(
    schedulesViewStateStore: SchedulesViewStateStore | IPreviewSchedulePageStore,
    isSticky: boolean
) {
    schedulesViewStateStore.isScheduleHeaderRowSticky = isSticky;
});
